import { config } from "@src/config";
import { OperatorEnum } from "@src/pages/intelligence-search/enum";
import { SmlJsonQueryFilter } from "@src/types/intelligence-search";
import dayjs from "dayjs";

export const mergeRequiredFilter = ({
    platform,
    timeRange,
    selectionFilters,
}: {
    platform: string[];
    timeRange: string[];
    selectionFilters: SmlJsonQueryFilter[];
}) => {
    const requireFilter: SmlJsonQueryFilter[] = [];
    if (platform) {
        requireFilter.push({
            name: "ama_app_id",
            meta: {
                id: "dimension.ama_app_id",
                name: "ama_app_id",
                asset_type: "dimension",
                title: "",
                data_type: "string",
                metadata: {},
            },
            operator: OperatorEnum.IN,
            values: platform,
        });
    }
    if (timeRange) {
        requireFilter.push({
            name: "date_tzutc",
            meta: {
                id: "dimension.date_tzutc",
                name: "date_tzutc",
                asset_type: "dimension",
                title: "",
                data_type: "date",
                metadata: {},
            },
            operator: OperatorEnum.BETWEEN,
            values: timeRange?.map((t: any) => dayjs(t).format(config.DATE_FORMAT)),
        });
    }
    return [...selectionFilters, ...requireFilter];
};
